import { createReducer } from 'reducers/utils'
import { Map, Set } from 'immutable'
import {
  SET_ERRORS,
  SET_ERROR,
  REMOVE_ERROR,
  RESET_ERRORS,
  SET_DIRTY,
  REMOVE_DIRTY,
  RESET_DIRTY,
} from 'actions/validation'

const initialState = Map({
  errors: Set(),
  dirty: Set(),
})

const handlers = {
  [SET_ERRORS]: setErrors,
  [SET_ERROR]: setError,
  [REMOVE_ERROR]: removeError,
  [RESET_ERRORS]: resetErrors,
  [SET_DIRTY]: setDirty,
  [REMOVE_DIRTY]: removeDirty,
  [RESET_DIRTY]: resetDirty,
}

export default createReducer(initialState, handlers)

function setErrors(state, { ids }) {
  return state.set('errors', Set(ids))
}

function setError(state, { id }) {
  return state.update('errors', (errors) => errors.add(id))
}

function removeError(state, { id }) {
  return state.update('errors', (errors) => errors.remove(id))
}

function resetErrors(state) {
  return state.set('errors', Set())
}

function setDirty(state, { id }) {
  return state.update('dirty', (dirty) => dirty.add(id))
}

function removeDirty(state, { id }) {
  return state.update('dirty', (dirty) => dirty.remove(id))
}

function resetDirty(state) {
  return state.set('dirty', Set())
}
